import { useState, useEffect } from "react";
import { GLTFLoader } from "three/addons/loaders/GLTFLoader.js";
import { Loader, Scene, Select } from "components";
import { modelSettings } from "settings";
import { getMeshes } from "helpers";
import { models } from "models";

const modelNames = ["bathroom", "bedroom"];

const App = () => {
    const [model, setModel] = useState({
        name: "bathroom",
        settings: modelSettings.bathroom,
        room: models.bathroom,
        meshes: null,
        mirrors: null,
    });
    const [isFree, setIsFree] = useState(false);
    const [isShowPerf, setIsShowPerf] = useState(false);

    // const gltfLoader = new GLTFLoader();

    // const [model, setModel] = useState({
    //     name: "bedroom",
    //     settings: modelSettings.bedroom,
    //     room: models.bedroom,
    // });

    useEffect(() => {
        const loadModel = async () => {
            const glft = await new GLTFLoader().loadAsync(model.room);
            const types = model.settings.typeMeshes;
            const { meshes, mirrors } = getMeshes(glft.scene, [], types);
            // meshes.push(...addEnvironment());
            setModel((prev) => ({ ...prev, meshes, mirrors }));
        };
        loadModel();
    }, [model.room, model.settings]);

    const changeModel = (name) => {
        setModel({
            name,
            settings: modelSettings[name],
            room: models[name],
            meshes: null,
        });
    };

    return (
        <div className="App">
            <div className="flexBox">
                <Select
                    list={modelNames}
                    onSelect={changeModel}
                    value={model.name}
                />
                <label className="flexBox" style={{ gap: "5px" }}>
                    <input
                        type="checkbox"
                        onChange={() => setIsFree((prev) => !prev)}
                        checked={isFree}
                    />
                    <p>Free camera</p>
                </label>

                <label className="flexBox" style={{ gap: "5px" }}>
                    <input
                        type="checkbox"
                        onChange={() => setIsShowPerf((prev) => !prev)}
                        checked={isShowPerf}
                    />
                    <p>Show Performance Monitor</p>
                </label>
            </div>
            {!model.meshes && <Loader />}
            {model.meshes && (
                <Scene
                    settings={model.settings}
                    startMeshes={model.meshes}
                    mirrors={model.mirrors}
                    isFree={isFree}
                    isShowPerf={isShowPerf}
                    // setFree={setIsFree}
                />
            )}
        </div>
    );
};

export default App;
